import React from 'react';
import Product from './Product';
import SimpleContext from './../context/SimpleContext';
import { useContext } from 'react';
import SabadKharidDrawer from './SabadKharidDrawer/SabadKharidDrawer';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router';


const Products = () => {

    const context = useContext(SimpleContext);
    const history = useHistory();

    const [modalShow, setModalShow] = useState(false); 


    return ( 
        <div className='products'>
            <div className="otherPagesHeader">
                <div onClick={context.drawerToggleClickHandler} className="barbuttonn">
                    <i className="fa fa-bars" />
                </div>
                <div className="headersNames">
                    <h6>محصولات</h6>
                </div>
                <div className="searchbtnn" onClick={()=>history.go(-1)}>
                    <i className="fa fa-chevron-left" />
                </div>
            </div>
            <div className="productHolder">
                {
                    context.productCopy.length ? 
                    context.productCopy.map((product,i) =>
                        <div key={i}>
                            <Product 
                            name = {product.name}
                            price = {product.price}
                            userPrice = {product.user_price}
                            slug = {product.slug}
                            min = {product.minimum}
                            max = {product.maximum}
                            proid = {product.brandID}
                            isSahmiyeh = {product.sahmie_bandi}
                            isvalid = {product.status}
                            numUnit = {product.number_in_unit}
                            numSale = {product.number_in_sale}
                            unit = {product.unit}
                            stock={product.stock}
                            category={product.category}
                            ulImg={product.ULImg}
                            dlImg={product.DLImg}
                            urImg={product.URImg}
                            drImg={product.DRImg}
                            mojud={product.FreshStatus}
                            goodsRef={product.goods_ref}
                            uniqueid={product.unique_id}
                            Role={product.Role}
                            /> 
                        
                        </div>
                    ):null
                }
            </div>

            <Modal
            show={modalShow}
            centered>
                <Modal.Header style={{width:"100%", backgroundColor:"#fb7a36"}} className="text-center p-3">
                    <p style={{margin:"0", color:"#fff", fontSize:"17px", textAlign:"center", marginRight:"38%"}}>
                    فیلتر کالاها
                    </p>
                </Modal.Header>
                <Modal.Body style={{padding:"2%",display: "flex", flexDirection: "column",justifyContent: "center",alignItems: "center"}}>

                    <p>فقط موجود <input type="radio" id="radio_1"/></p>
                    <p> کالاهای پرگردش <input type="radio" id="radio_1"/></p>

                </Modal.Body>
                <Modal.Footer style={{padding:"3%"}}>
                    <Button variant="success" style={{width:"100%"}} onClick={()=>setModalShow(false)}>فیلتر کن</Button>
                </Modal.Footer>
                </Modal>

            <div className="SabadDrawer" >
                <SabadKharidDrawer/>
            </div>
            
        </div> 
     );
}
 
export default React.memo(Products);